import Sidbarv2 from "../../Workspace-v2/Sidbarv2";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import SearchIcon from "@mui/icons-material/Search";
import Badge from "@mui/material/Badge";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
// import Button from "@mui/material/Button";
import Popover from "@mui/material/Popover";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import { motion } from "framer-motion";
import { Spinner } from "react-bootstrap";


import "../../../../src/WorkSpace/SignUp2.css";
import { Navbar } from "../../../Components/Navbar";
import { getAPI } from "../../../services/api/StandAlone/projectAPIs";
// import PresetInfo from "../../../PrivatePages/consolidatedFinancialStatement/PresetInfo";


import LinearProgress, {
  linearProgressClasses,
} from "@mui/material/LinearProgress";
import { useHistory, useLocation } from "react-router";
import { GetAllProject, updateProject, getTemplatesApiHandler } from "../ApiServices/apiHandler";
import React, { useEffect, useState, useRef } from "react";

import moment from "moment";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import * as actionTypes from "../../../redux/actionTypes";
import swal from "sweetalert";
import "../../../../src/WorkSpace/font.css";
import { fetchWSData } from "../../../redux/actions/workspace/actionWorkspace";
import EditProject from "../Modal/editProject";
import TranslateFSModal from "../Modal/TranslateFSModal";
import Checkmark from "../../../myfin_v2/assets/icons/Check(circle).png";


// import SideBarv2 from '../../WorkSpace/Workspace-v2/Sidbarv2';
import SideBarv2 from '../../../WorkSpace/Workspace-v2/Sidbarv2';
import commoncss from "../../../myfin_v2/css/common.module.css";
import Sidebar from "../../../myfin_v2/elements/Sidebar";
import { Button } from "../../../myfin_v2/elements/Button";
import StatusIndicator from "../../../myfin_v2/elements/StatusIndicator";
import standalonecss from "../../../myfin_v2/css/standalone.module.css";
import bookclosuretablecss from "../../../myfin_v2/css/bookclosuretable.module.css";
import buttoncss from "../../../myfin_v2/css/button.module.css";
import { ReactComponent as PlusIcon } from "../../../myfin_v2/assets/icons/plus.svg";
import { ReactComponent as PlusIconPrimary } from "../../../myfin_v2/assets/icons/plusprimary.svg";
import { ReactComponent as PlusIcons } from "../../../myfin_v2/assets/icons/plus.svg";
import emptyState from "../../../myfin_v2/assets/icons/Empty State.png";
import {ReactComponent as MenuDotBlack} from "../../../myfin_v2/assets/icons/menuDotBlack.svg";
import { ReactComponent as DeleteIcon } from "../../../myfin_v2/assets/icons/delete.svg";
import tablecss from "../../../myfin_v2/css/table.module.css";


const FinancialStatement = (props) => {
  const isMounted = useRef(true);
  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);

  const user = JSON.parse(localStorage.getItem("user"));
  // for popover
  const [anchorEl, setAnchorEl] = useState(null);
  const tableData = useSelector((state) => state.reducer.tableData);
  const [projectId, setProjectId] = useState("");
  const workspace_data = useSelector((state) => state.WSReducer);
  const [allProjectData, setallProjectData] = useState("");
  const [editModal, handleEditModal] = useState(false);
  const [editProject, setEditProject] = useState({
    company: "",
    name_finance: "",
    nature_finance: "",
    gaap: "",
    account: "",
    "": "",
  });
  const [search, setSearch] = useState("");
  const [showTranslateFSModal, setShowTranslateFSModal] = useState(false);
  const [loader, setLoader] = useState(true);
  const [renameModalOpen, setRenameModalOpen] = useState(false);
  const [selectedProjectId, setSelectedProjectId] = useState("");
  const [selectedProjectName, setSelectedProjectName] = useState("");
  const [isRenaming, setIsRenaming] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [deleteProjectId, setDeleteProjectId] = useState("");
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [successPopupMessage, setSuccessPopupMessage] = useState("");

  const handleClick = (event, id, data) => {
    setAnchorEl(event.currentTarget);
    setProjectId(id);
    setallProjectData(data);
  };

  const handleClose = () => {
    setAnchorEl(null);
    handleEditModal(false);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;
  // end popover
  const location = useLocation();
  const dispatch = useDispatch();
  let history = useHistory();
  let a = location.pathname;
  let w_id = a.split("/");
  const [allProject, setAllProject] = useState([]);
  const [allTemplates, setAllTemplates] = useState([]);
  const [progressData, setProgressData] = useState({});

  useEffect(() => {
    if (workspace_data.isSuccess === false) {
      dispatch(fetchWSData(w_id[2]));
    }
    AllProject();
    getTemplates();
  }, []);

  useEffect(() => {
    if (workspace_data.isSuccess === false) {
      dispatch(fetchWSData(w_id[2]));
    }
    AllProject();
  }, [showTranslateFSModal]);

  // Polling for progress updates
  useEffect(() => {
    let interval;
    const hasInProgress = allProject.some(
      (p) => p?.grouping_status?.toLowerCase() === "in progress"
    );

    if (hasInProgress) {
      interval = setInterval(() => {
        AllProject();
      }, 5000); // poll every 5 seconds
    }

    return () => {
      if (interval) clearInterval(interval);
    };
  }, []);

  // const fetchProjectProgress = async (pId) => {
  //   try {
  //     const auth = localStorage.getItem("auth_token");
  //     let headers = { "x-auth-token": auth };
  //     const tbRes = await axios.get(`api/v1/tb-onboarding/get-tb/${pId}`, { headers });
  //     const tb_id = tbRes.data.tb_id;
  //     const convRes = await axios.get(`api/v1/conventional-mode/fetch/${pId}/${tb_id}`, { headers });
  //     const response = convRes.data;

  //     const lineItems = response?.data?.line_items || [];
  //     const wholeValue = response?.records || lineItems.length || 1;
  //     const partValue = lineItems.reduce((count, item) => {
  //       const hasCyMap = item?.map_data?.cy_map?.sub_grp;
  //       const hasPyMap = item?.map_data?.py_map?.sub_grp;
  //       if (hasCyMap && hasPyMap) return count + 1;
  //       if (hasCyMap || hasPyMap) return count + 0.5;
  //       if (item.sub_grp) return count + 1;
  //       return count;
  //     }, 0) || 0;

  //     const percentage = Math.floor((partValue / wholeValue) * 100);
  //     setProgressData((prev) => ({ ...prev, [pId]: percentage }));
  //   } catch (error) {
  //     console.log("Error calculating progress:", error);
  //   }
  // };

  // useEffect(() => {
  //   if (allProject.length > 0) {
  //     allProject.forEach((project) => {
  //       if (project?.grouping_status?.toLowerCase() === "in progress") {
  //         fetchProjectProgress(project._id);
  //       }
  //     });
  //   }
  // }, [allProject]);

  const AllProject = async () => {
    const res = await GetAllProject(w_id[2]);
    if (res.status === 200) {
      if (isMounted.current) {
        setAllProject(res.data.project);
        setLoader(false);
      }
    }
  };

  const getTemplates = () => {
    getTemplatesApiHandler({ sortField: "createdAt", sortOrder: "desc" })
      .then((response) => {
        if (response?.data?.success === true) {
          if (isMounted.current) {
            setAllTemplates(response.data.groupingTemplateArray || []);
          }
        }
      })
      .catch((error) => {});
  };

  const handleRenameSubmitModal = async () => {
    if (isRenaming) return;
    
    if (selectedProjectName.trim() === "") {
      swal("", "Name cannot be empty", "warning");
      return;
    }

    setIsRenaming(true);
    setLoader(true);
    
    const auth = localStorage.getItem("auth_token");
    const headers = {
      "x-auth-token": auth,
    };

    try {
      const response = await axios.patch(
        `/api/v1/project/renameProject?projectID=${selectedProjectId}`,
        { project_name: selectedProjectName },
        { headers }
      );
      if (response.status === 200 || response.status === 201) {
        setSuccessPopupMessage("FS renamed successfully!");
        setShowSuccessPopup(true);
        setTimeout(() => setShowSuccessPopup(false), 2000);
        setRenameModalOpen(false);
        AllProject();
      } else {
        swal("", "Failed to rename FS", "error");
      }
    } catch (error) {
      console.error("Rename FS error:", error);
      swal("", error.response?.data?.message || "Error renaming FS", "error");
    } finally {
      setIsRenaming(false);
      setLoader(false);
    }
  };

  const handleDeleteSubmit = async (pId) => {
    setLoader(true);
    const auth = localStorage.getItem("auth_token");
    const headers = {
      "x-auth-token": auth,
    };

    try {
      const response = await axios.delete(
        `/api/v1/project/deleteProject?projectID=${pId}`,
        { headers }
      );
      if (response.status === 200 || response.status === 201) {
        setSuccessPopupMessage("FS has been deleted!");
        setShowSuccessPopup(true);
        setTimeout(() => setShowSuccessPopup(false), 2000);
        AllProject();
      } else {
        swal("", "Failed to delete FS", "error");
      }
    } catch (error) {
      console.error("Delete FS error:", error);
      swal("", error.response?.data?.message || "Error deleting FS", "error");
    } finally {
      setLoader(false);
    }
  };
  function handleEnter(e, id, det) {
    const auth = localStorage.getItem("auth_token");
    let headers = {
      "x-auth-token": auth,
    };
    setLoader(true);

    const targetProjectName = det?.project_name || "";
    const targetWsId = w_id[2] || "";
    const targetWsName = workspace_data?.response?.[0]?.workspace_name || localStorage.getItem("workspaceName") || "";

    if (targetProjectName) {
      sessionStorage.setItem("adj_standalone_name", targetProjectName);
      localStorage.setItem("projectName", targetProjectName);
    }
    if (targetWsId) {
      sessionStorage.setItem("adj_workspace_id", targetWsId);
      localStorage.setItem("standalone_workspace_id", targetWsId);
      localStorage.setItem("ws_id", targetWsId);
    }
    if (targetWsName) {
      sessionStorage.setItem("adj_workspace_name", targetWsName);
      localStorage.setItem("workspaceName", targetWsName);
    }
    sessionStorage.setItem("adj_project_id", id);

    axios
      .get(`api/v1/tb-onboarding/get-tb/${id}`, { headers })
      .then((response) => {
        dispatch({ type: actionTypes.SET_TB_ID, payload: response.data.tb_id });
        window.localStorage.setItem("tb_id", response.data.tb_id);
        localStorage.setItem("project_id", response.data.project_id);
        sessionStorage.setItem("tb_id", response.data.tb_id);
        sessionStorage.setItem("project_id", response.data.project_id);
        sessionStorage.setItem("adj_project_id", response.data.project_id);
        axios
          .get(`api/v1/grouping/fs/${id}`, { headers })
          .then((res) => {
            if (res.data.fs_grp === []) {
              setLoader(false);

              return;
            }
            const gp_data = {};
            gp_data.grp = res.data.fs_grp;
            dispatch({
              type: actionTypes.SET_EDITSUBGROUPING,
              payload: gp_data,
            });
            setLoader(false);

          })
          .catch((error) => {
            console.log(error.response, "error");
          });
        
        if (Number(det?.mappingPercentage) === 100) {
          history.push(`/myfinV2/standalonefs`);
        } else {
          history.push(`/templateV2/${id}`);
        }
      })
      .catch((error) => {
        console.log(error.response, "error");
        // swal("", "Cannot found any TB inside this project", "error");
        history.push("/createProject/uploadTb");
      });
  }
  const handleData = () => {
    if (user.responsibilities === "approver" || user.responsibilities === "view") {
      swal(
        "Warning",
        "You Don't have Access to Create Financial Statement",
        "warning"
      );
    } else {
      history.push(`/createProject/QuestionnaireNew/${w_id[2]}`);
    }
  };

  const handleEdit = (data) => {
    if (user.responsibilities === "approver" || user.responsibilities === "view") {
      swal(
        "Warning",
        "You Don't have Access to Edit Financial Statement",
        "warning"
      );
    } else {
      handleEditModal(true);
    }
  };

  const goToPage = () => {
    if (user.responsibilities === "approver" || user.responsibilities === "view") {
      swal("warning", "You don't have access to Go", "warning");
    } else {
      history.push('/preset-information');
    }
  };

  const handleChnageEdit = (data, field) => {
    setEditProject({ ...editProject, [field]: data });
  };

  const submitEdit = async (id) => {
    let alldata = {
      company: editProject.company,
      project_name: editProject.name_finance,
      company_type: editProject.nature_finance,
      gaap_selection: editProject.gaap,
      preset_name: editProject.account,
    };
    const res = await updateProject(id, alldata);
    if (res.status === 200) {
      handleClose();
      swal("", "Updated Successfully", "success");
      AllProject();
    }
  };


  //search option
  const handleChange = (event) => {
    const searchData = event.target.value;
    setSearch(searchData);
    if (searchData === "") {
      AllProject();
    } else {
      const filerData = allProject.filter((project) =>
        project?.project_name.includes(searchData)
      );
      setAllProject(filerData);
    }
  };

  const tableHeaders = {
    financialStatments: "FINANCIAL STATEMENTS",
    companyName: "COMPANY NAME",
    gaap: "GAAP",
    groupingStatus: "GROUPING STATUS",
    // logicalErrors: "LOGICAL ERRORS",
    functionalCurrency: "CURRENCY",
    selectTemplate: "TEMPLATE",
    actions: ""  ,
  };

  const headerClasses = {
    taskTemplateName: "stclTableTemplateNameTh",
  };
  return (
    <>

      <div className={commoncss.pageLayout}>
        {/* <Navbar /> */}
        <Sidebar />
        <div className={`d-flex ${commoncss.pageContent}`}>
          <motion.div
            initial={{ x: -100, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            exit={{ x: 100, opacity: 0 }}
            transition={{ duration: 0.5, ease: "easeInOut" }}
          >
            <SideBarv2 w_id={w_id} />
          </motion.div>

          <div className={standalonecss.content}>
            <motion.div

              initial={{ x: 100, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              exit={{ x: 0, opacity: 0 }}
              transition={{ duration: 0.5, ease: "easeInOut" }}
              className={standalonecss.headerPadding}
              style={{ padding: "10px 20px 5px 20px" }}
            >
              <div
                // initial={{ y: -100, opacity: 0 }}
                // animate={{ y: 0, opacity: 1 }}
                // exit={{ y: 0, opacity: 0 }}
                // transition={{ duration: 0.5, ease: "easeInOut" }}
                className={standalonecss.headerContent}>
                <div style={{ width: "20rem", zIndex: 100 }}>
                  <label className={commoncss.fs20}>Financial Statements</label>
                </div>
                <div className='d-flex'>
                  {workspace_data.response[0]?.access_status === "view" ? (
                    <Button
                      class_={commoncss.fs14}
                      btnColor={buttoncss.primary}
                      icon={<PlusIcons />}
                      label="Create Financial Statement"
                      isEnabled={false}
                    />
                  ) : (
                    <>
                      <Button
                        class_={commoncss.fs14}
                        btnColor={buttoncss.greyBg}
                        label="Translate FS"
                        onClick={() => { setShowTranslateFSModal(true) }}
                      />&ensp;
                      <Button
                        class_={commoncss.fs14}
                        btnColor={buttoncss.primary}
                        icon={<PlusIcons />}
                        label="Create Financial Statement"
                        onClick={handleData}
                      />
                    </>
                  )}

                </div>
              </div>
            </motion.div>

            <motion.div
              initial={{ x: 100, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              exit={{ x: 0, opacity: 0 }}
              transition={{ duration: 0.5, ease: "easeInOut" }}
              className={`${standalonecss.fsTableContainer} mt-2`}
              style={{ position: "relative", width: "98%", height: "90vh", margin: "0 auto" }}
            >

            {loader && (
              <div
                style={{
                  position: "absolute",
                  inset: 0,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  zIndex: 200
                }}
              >
                <div className={commoncss.fsTableLoaderDiv}>
                  <Spinner animation="grow" size="sm" />
                  <Spinner animation="grow" style={{ margin: "1rem" }} />
                  <Spinner animation="grow" size="sm" />
                </div>
              </div>
            )}

              <div className={standalonecss.standaloneTableContainer}  style={{
                filter: loader ? "blur(3px)" : "none",
                transition: "0.2s ease"
              }}>
                <table className={standalonecss.standaloneTable}>
                  <thead>
                    <tr  style={{borderBottom: "1px solid var(--border-color"}}>
                      {Object.entries(tableHeaders).map(([key, label]) => {
                        let headerStyle = { paddingLeft: "12px", paddingRight: "12px" };
                        if (label === "FINANCIAL STATEMENTS") {
                          headerStyle.width = "25%";
                        } else if (label === "TEMPLATE") {
                          headerStyle.width = "20%";
                          headerStyle.paddingLeft = "44px";
                        } else if (label === "GROUPING STATUS") {
                          headerStyle.width = "18%";
                          headerStyle.textAlign = "center";
                        } else if (label === "CURRENCY") {
                          headerStyle.width = "13%";
                          headerStyle.textAlign = "center";
                        } else if (label === "COMPANY NAME") {
                          headerStyle.width = "12%";
                          headerStyle.paddingLeft = "18px";
                        } else if (label === "GAAP") {
                          headerStyle.width = "12%";
                          headerStyle.textAlign = "center";
                        } else if (label === "") {
                          headerStyle.width = "5%";
                          headerStyle.textAlign = "right";
                        }

                        return (
                          <th
                            key={key}
                            style={headerStyle}
                          >
                            {label}
                          </th>
                        );
                      })}
                    </tr>
                  </thead>
                
              <tbody>
                {allProject.length > 0 ? (
                  allProject.map((det, index) => (
                    <React.Fragment key={index}>
                      <tr>
                        <td
                          style={{ cursor: "pointer" }}
                          onClick={(e) => handleEnter(e, det._id, det)}
                        >
                          {det.project_name}
                        </td>

                        <td>
                          {det?.companyData?.company_name || det?.company?.company_name || det?.company_name || "-"}
                        </td>

                        <td style={{ textAlign: "center" }}>
                          {det?.gaap_selection || det?.gaap || "-"}
                        </td>

    

                        <td style={{ textAlign: "center", paddingLeft: "12px", paddingRight: "12px" }}>
                          <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-start", gap: "6px", margin: "0 auto", width: "115px" }}>
                            <StatusIndicator status={det?.grouping_status} />
                            {det?.grouping_status?.toLowerCase() === "in progress" && (
                              <span
                                style={{
                                  fontSize: "12px",
                                  fontWeight: 600,
                                  color: "#e5a503",
                                }}
                              >
                               {det?.mappingPercentage || 0}%   
                            </span>
                            )}
                          </div>
                        </td>

                        <td style={{ textAlign: "center", paddingLeft: "12px", paddingRight: "12px" }}>
                          {det?.functional_currency || det?.functionalCurrency || det?.currency || "-"}
                        </td>

                        <td style={{ textAlign: "left", paddingLeft: "44px", paddingRight: "12px" }}>
                          {det?.groupingTemplateID?.name || det?.template_name || allTemplates.find(t => t._id === det?.groupingTemplateID)?.name || "-"}
                        </td>

                        <td style={{ verticalAlign: "middle", textAlign: "right", paddingRight: "15px" }}>
                          <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
                            <MenuDotBlack
                              style={{ cursor: "pointer" }}
                              onClick={(e) => handleClick(e, det._id, det)}
                            />
                          </div>
                        </td>
                      </tr>
                      <Popover
                        open={Boolean(anchorEl) && projectId === det._id}
                        anchorEl={anchorEl}
                        onClose={() => setAnchorEl(null)}
                        anchorOrigin={{
                          vertical: "bottom",
                          horizontal: "right",
                        }}
                        transformOrigin={{
                          vertical: "top",
                          horizontal: "right",
                        }}
                        PaperProps={{
                          sx: {
                            borderRadius: "10px",
                            boxShadow: "0px 4px 12px rgba(0,0,0,0.1)",
                            minWidth: "160px",
                            padding: "6px 0",
                          },
                        }}
                      >
                        <div style={{ display: "flex", flexDirection: "column", minWidth: "120px" }}>
                          <div
                            style={{
                              padding: "10px 16px",
                              fontSize: "13px",
                              cursor: "pointer",
                              color: "#4D6D64",
                              textAlign: "center", 
                            }}
                            onMouseEnter={(e) => (e.target.style.background = "#f4faf5")}
                            onMouseLeave={(e) => (e.target.style.background = "transparent")}
                            onClick={() => {
                              setAnchorEl(null);
                              setSelectedProjectId(det._id);
                              setSelectedProjectName(det.project_name);
                              setRenameModalOpen(true);
                            }}
                          >
                            Rename FS
                          </div>

                          <div
                            style={{
                              height: "1px",
                              background: "#eaeeed",
                              margin: "0 12px",   
                            }}
                          />

                          <div
                            style={{
                              padding: "10px 16px",
                              fontSize: "13px",
                              cursor: "pointer",
                              color: "#4D6D64",
                              textAlign: "center", 
                            }}
                            onMouseEnter={(e) => (e.target.style.background = "#f4faf5")}
                            onMouseLeave={(e) => (e.target.style.background = "transparent")}
                            onClick={() => {
                              setAnchorEl(null);
                              if (user.responsibilities === "approver" || user.responsibilities === "view") {
                                swal(
                                  "Warning",
                                  "You Don't have Access to Delete Financial Statement",
                                  "warning"
                                );
                              } else {
                                setDeleteProjectId(det._id);
                                setDeleteModalOpen(true);
                              }
                            }}
                          >
                            Delete FS
                          </div>
                        </div>
                      </Popover>

                    </React.Fragment>
                  ))
                ) : (
                  <tr>
                    <td colSpan="7" style={{ textAlign: "center", height: "65vh" }}>
                      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: "100%", paddingTop: "30px" }}>
                        <img src={emptyState} alt="No Data" style={{ width: "280px", marginBottom: "10px" }} />
                        <span style={{ fontSize: "22px", color: "#183930", fontWeight: 600, marginBottom: "5px" }}>Nothing here yet</span>
                        <span style={{ fontSize: "19px", color: "#4D6D64", fontWeight: 400, marginBottom: "20px" }}>Create FS using below button</span>
                        {workspace_data?.response?.[0]?.access_status === "view" ? (
                          <Button
                            class_={commoncss.fs14}
                            btnColor={buttoncss.secondary}
                            label="Create Financial Statement"
                            icon={<PlusIconPrimary />}
                            isEnabled={false}
                          />
                        ) : (
                          <Button
                            class_={commoncss.fs14}
                            btnColor={buttoncss.secondary}
                            icon={<PlusIconPrimary />}
                            label="Create Financial Statement"
                            onClick={handleData}
                          />
                        )}
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
                  
                </table>
              </div>
            </motion.div>
          </div>

        </div>
      </div>

      <EditProject
        open={editModal}
        handleClose={handleClose}
        // editData={companyData}
        handleChnageEdit={handleChnageEdit}
        submitEdit={submitEdit}
        allProjectData={allProjectData}
      />
      {showTranslateFSModal && (
      <TranslateFSModal
        mode="standalone"
        allProject={allProject}
        setShowTranslateFSModal={setShowTranslateFSModal}
      />
    )}

      <Modal
        open={renameModalOpen}
        onClose={() => setRenameModalOpen(false)}
        aria-labelledby="rename-modal-title"
        aria-describedby="rename-modal-description"
      >
        <Box
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "500px",
            background: "#ffffff",
            borderRadius: "16px",
            boxShadow: "0px 10px 30px rgba(0, 0, 0, 0.15)",
            padding: "0px 28px 28px 28px",
            outline: "none",
            display: "flex",
            flexDirection: "column",
            gap: "20px",
            fontFamily: '"DM Sans", sans-serif',
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginLeft: "-28px",
              marginRight: "-28px",
              paddingLeft: "28px",
              paddingRight: "28px",
              paddingTop: "14px",
              paddingBottom: "14px",
              borderBottom: "1px solid #eaeeed",
            }}
          >
            <Typography id="rename-modal-title" style={{ fontFamily: '"DM Sans", sans-serif', fontSize: "18px", fontWeight: "500", color: "#00000"}}>
              Rename Financial Statement
            </Typography>
            <CloseIcon
              onClick={() => setRenameModalOpen(false)}
              style={{ cursor: "pointer", color: "#66827a", fontSize: "24px" }}
            />
          </div>
          
          <div style={{ display: "flex", flexDirection: "column", gap: "8px", marginTop: "8px", marginBottom: "10px" }}>
            <label style={{ fontFamily: '"DM Sans", sans-serif', fontSize: "12px", fontWeight: "400", color: "#205a46" }}>
              Enter FS name
            </label>
            <input
              type="text"
              value={selectedProjectName}
              onChange={(e) => setSelectedProjectName(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleRenameSubmitModal();
                }
              }}
              autoFocus
              style={{
                fontFamily: '"DM Sans", sans-serif',
                width: "100%",
                height: "38px",
                padding: "10px 16px",
                border: "1.5px solid #c2e6d1",
                borderRadius: "8px",
                fontSize: "15px",
                color: "#333333",
                background: "#f4faf5",
                outline: "none",
              }}
            />
          </div>
          
          <div style={{ display: "flex", justifyContent: "space-between", marginTop: "10px" }}>
            <button
              onClick={() => setRenameModalOpen(false)}
              className={`${buttoncss.custom_btn} ${buttoncss["custom-btn"]} ${buttoncss.secondary}`}
              style={{
                fontFamily: '"DM Sans", sans-serif',
                height: "38px",
                minWidth: "90px",
                cursor: "pointer",
                borderRadius: "8px",
                fontWeight: "500",
                fontSize: "15px",
              }}
            >
              Cancel
            </button>
            <button
              onClick={handleRenameSubmitModal}
              className={`${buttoncss.custom_btn} ${buttoncss["custom-btn"]} ${buttoncss.primary}`}
              style={{
                fontFamily: '"DM Sans", sans-serif',
                height: "38px",
                minWidth: "90px",
                cursor: "pointer",
                borderRadius: "8px",
                fontWeight: "500",
                fontSize: "15px",
              }}
            >
              Update
            </button>
          </div>
        </Box>
      </Modal>

      <Modal
        open={deleteModalOpen}
        onClose={() => setDeleteModalOpen(false)}
        aria-labelledby="delete-modal-title"
        aria-describedby="delete-modal-description"
      >
        <Box
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "500px",
            background: "#ffffff",
            borderRadius: "16px",
            boxShadow: "0px 10px 30px rgba(0, 0, 0, 0.15)",
            padding: "36px",
            outline: "none",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "24px",
          }}
        >
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "10px", textAlign: "center", marginTop: "12px" }}>
            <Typography id="delete-modal-title" style={{ fontSize: "22px", fontWeight: "600", color: "#111111", fontFamily: "DM Sans, sans-serif" }}>
              Are you sure?
            </Typography>
            <Typography style={{ fontSize: "16px", color: "#66827a", fontWeight: "400", fontFamily: "DM Sans, sans-serif" }}>
              Once deleted, you will not be able to view the project
            </Typography>
          </div>
          
          <div style={{ display: "flex", justifyContent: "center", gap: "26px", marginTop: "10px" }}>
            <button
              onClick={() => {
                setDeleteModalOpen(false);
                handleDeleteSubmit(deleteProjectId);
              }}
              className={`${buttoncss.custom_btn} ${buttoncss["custom-btn"]} ${buttoncss.dangerDeleteModelBtn}`}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "8px",
                height: "38px",
                minWidth: "120px",
                background: "#e30000",
                color: "#ffffff",
                border: "none",
                borderRadius: "8px",
                fontWeight: "500",
                fontSize: "13px",
                cursor: "pointer",
                padding: "10px 16px",
                fontFamily: "DM Sans, sans-serif",
              }}
            >
              <DeleteIcon style={{ width: "16px", height: "16px" }} />
              Delete
            </button>
            <button
              onClick={() => setDeleteModalOpen(false)}
              className={`${buttoncss.custom_btn} ${buttoncss["custom-btn"]} ${buttoncss.deleteModelBtn_secondary_del}`}
              style={{
                height: "38px",
                minWidth: "100px",
                background: "#ffffff",
                color: "#205a46",
                border: "1px solid #c2e6d1",
                borderRadius: "8px",
                fontWeight: "500",
                fontSize: "13px",
                cursor: "pointer",
                padding: "18px 18px",
                fontFamily: "DM Sans, sans-serif",
              }}
            >
              Cancel
            </button>
          </div>
        </Box>
       </Modal>
      {showSuccessPopup && (
        <div className={commoncss.overlay} style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, zIndex: 99999 }}>
          <div className={commoncss.popup} style={{ width: "380px", height: "245px"}}>
            <div className={commoncss.iconWrapper} >
              <img src={Checkmark} alt="Success" width={90} height={90} />
            </div>
            <p className={commoncss.restoreText}>{successPopupMessage}</p>
          </div>
        </div>
      )}
    </>
  );
};

export default FinancialStatement;
